export default "__VITE_ASSET__ce0e7c2b__"